import React from 'react';
import styled from 'styled-components';

const DashboardGuest = ({  bgImage }) => {
  return (
    <DashboardBox>
      <DashboardHeader>
        <DashboardTitle>Dashboard</DashboardTitle>
      </DashboardHeader>

      <DashboardPreview bgImage={bgImage} />

    </DashboardBox>
  );
};

export default DashboardGuest;


const DashboardBox = styled.div`
  width: 420px;
  height: 700px;
  margin-top: -15%; 
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  padding: 5px;
`;

const DashboardHeader = styled.div`
  background: linear-gradient(45deg,rgb(13, 207, 55),rgb(13, 110, 9));
  padding: 5px 5px;
`;

const DashboardTitle = styled.h2`
  font-size: 1.2rem;
  color: #fff;
  font-weight: 600;
  margin-top : -9px;
   margin-bottom : -7px;
`;

const DashboardPreview = styled.div`
  width: 100%;
  height: 180px;
  border-radius: 1px;
  background-image: ${(props) => `url(${props.bgImage})`};
  background-size: cover;
  background-position: center;
`;
